export const irArriba = () => {
    window.scrollTo(0, 0)
}